import { HTMLProps } from 'react';

import styles from './RadioButton.module.scss';

export type RadioButtonProps = Omit<HTMLProps<HTMLInputElement>, 'type'> & {};

const RadioButton = ({ ...htmlProps }: RadioButtonProps) => (
  <label className={styles.container} htmlFor={htmlProps.id}>
    <input type="radio" {...htmlProps} />
    <span className={styles.title}>{htmlProps.label}</span>
  </label>
);

export default RadioButton;
